import { FacetGroupSelect } from "./FacetGroupSelect";
import { listFeatures, submitActionTrackingFrom } from "../tracking/FeatureTracking";
import type { TrackingLabels } from "../tracking/TrackingLabels";

export class FacetGroupSelectAction implements EventListenerObject {
  /*               */
  constructor(
    readonly select: FacetGroupSelect,
    private readonly initialFacetGroup = select.selectedOption?.value,
  ) {}

  /*                  */

  static on(select: FacetGroupSelect, listener = new FacetGroupSelectAction(select)) {
    select.select.addEventListener("change", listener, {
      passive: true,
    });
    select.select.form?.addEventListener("reset", listener, {
      passive: true,
    });
  }

  /*                  */

  handleEvent(event: Event) {
    if (event.target instanceof HTMLSelectElement) {
      const facetGroup = event.target.value;
      const updated = this.select.activateFacetGroup(facetGroup);

      if (updated) {
        const labels: Partial<TrackingLabels> = {
          san_DefaultFacetChange: facetGroup,
          san_DefaultFacet: this.initialFacetGroup || "none",
        };
        this.select.facetGroups.forEach((group) => {
          if (group.active) {
            /*                                                     */
            /*                                                                                             */
            group.updateChildrenFeatureStatus("loaded", "visible");
            submitActionTrackingFrom(group.facetGroup, "open", labels, [
              ...listFeatures(["Filter-Overview"]),
              ...listFeatures(["Filter"], undefined, `[id="${this.select.select.form.id}"]`),
            ]);
          } else {
            group.updateChildrenFeatureStatus("visible", "loaded");
          }
        });
      }
    } else {
      /*              */
      this.select.activateFacetGroup(this.initialFacetGroup);
    }
  }
}
